import { Skeleton, Stack } from '@chakra-ui/react'
import React from 'react'

const ChatLoading = () => {
  return (
    <Stack>

  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />
  <Skeleton height='33px' />

    </Stack>
  )
}

export default ChatLoading